import { useEffect, useRef, KeyboardEvent } from 'react'
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import { LuX } from 'react-icons/lu'
import useSearch, { closeSearch, clearSearch, setSearchQuery, setSearchPosition } from '../models/useSearch'
import Modal from './Modal'

export default function ModalSearch() {
  const open = useSearch(s => s.open)
  const query = useSearch(s => s.query)
  const position = useSearch(s => s.position)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (open) {
      const id = window.setTimeout(() => inputRef.current?.focus(), 0)
      return () => window.clearTimeout(id)
    }
  }, [open, position])

  const keyDownHandler = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      closeSearch()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      clearSearch()
      closeSearch()
    }
  }

  const clearHandler = () => {
    clearSearch()
    inputRef.current?.focus()
  }

  return (
    <Modal
      open={open}
      onClose={closeSearch}
      // The search row has its own clear button at the right; ESC closes search.
      hideClose
      maxWidth="sm"
      disableOverflow
      position={position}
      onPositionChange={setSearchPosition}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: 'center',
          px: 2,
          py: 0.5
        }}>
        <InputBase
          inputRef={inputRef}
          value={query}
          onChange={e => setSearchQuery(e.target.value)}
          onKeyDown={keyDownHandler}
          placeholder="Search"
          fullWidth
          sx={{ fontSize: 20 }}
        />
        {query.length > 0 && (
          <IconButton size="small" onClick={clearHandler} aria-label="Clear search">
            <LuX fontSize={18} />
          </IconButton>
        )}
      </Stack>
    </Modal>
  )
}
